import Moment from 'moment';
export function format(date) {
    return Moment(date).format('DD/MM/YYYY - HH:mm');
}
